import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import '@/styles/global.css';
import '@/shared/i18n';

import { router } from './router';

import { initSentry } from '@/shared/observability/sentry-setup';
import { trackWebVitals } from '@/shared/observability/web-vitals';

// Init Sentry ANTES do createRoot — captura erros de bootstrap (ex: provider
// que falha na primeira render). No-op se VITE_SENTRY_DSN ausente.
//
// `initSentry()` retorna Promise (carrega o SDK via lazy import — Phase 16),
// mas nao queremos bloquear o render. `void` marca explicitamente como
// fire-and-forget. Erros do load do SDK sao logados pela funcao.
void initSentry();

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// Web Vitals: coleta CLS/INP/LCP/TTFB e envia como breadcrumbs ao Sentry
// (Phase 18). Apos o `createRoot.render` para nao competir com a renderizacao
// inicial. Lazy import da lib `web-vitals` (~3KB gzip).
void trackWebVitals();
